import { FC, useEffect } from "react";
import { FilterSidebar } from "@mibuildweb/components";
import { OrderSearchFilters } from "../OrderSearch.types";
import { useOrderFilters } from "../hooks/useOrderFilters";

const ORDER_SEARCH_BASE_URL = "/orders/all/list";

export const OrdersFilterSidebar: FC<OrdersFilterSidebarProps> = ({
  filters,
  initialFilters,
  onFilterSearchPress,
  onResetFilters,
}) => {
  const {
    groupByOptions,
    sortByOptions,
    dataFilters,
    getOrdersSearchDataFilters,
    isLoading,
  } = useOrderFilters();

  useEffect(() => {
    getOrdersSearchDataFilters();
  }, []);

  return (
    <FilterSidebar
      groupByOptions={groupByOptions}
      sortByOptions={sortByOptions}
      filters={filters}
      initialFilters={initialFilters}
      onApplyFilters={onFilterSearchPress}
      onResetFilters={onResetFilters}
      dataFilters={dataFilters}
      baseUrlForFilteredSearch={ORDER_SEARCH_BASE_URL}
      loading={isLoading}
    />
  );
};

interface OrdersFilterSidebarProps {
  filters: OrderSearchFilters;
  initialFilters: OrderSearchFilters;
  onFilterSearchPress: (filters: OrderSearchFilters) => void;
  onResetFilters: () => void;
}
